import { Controller } from '@hotwired/stimulus'
import { toggleClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["addon", "checkboxGroup"]

  initialize() {
    this.addonsState = {}

    this._updateAddonsState()

    this._scrollToSection()
  }

  trackProductEvents() {
    this._updateAddonsState()
  }

  // selects all grouped checkboxes and process the addons
  toggleSelectAll(evt) {
    evt.preventDefault()
    const link = evt.target.closest("a")
    toggleClass(link, "-selected")

    const linkGroup = link.dataset.group
    const checkboxGroup = this.checkboxGroupTargets.find((group) => group.dataset.group === linkGroup)
    const checks = this.addonTargets.filter((addon) => checkboxGroup.contains(addon))

    const selectAllSelected = link.classList.contains("-selected")

    checks.forEach((checkbox) => {
      if (selectAllSelected) {
        checkbox.checked = true
      } else {
        checkbox.checked = false
      }
    })

    link.closest("form").dispatchEvent(new Event("change"))

    this.trackProductEvents()
  }

  _updateAddonsState() {
    this.addonTargets.forEach((addon) => {
      this.addonsState[addon.id] = {
        checked: addon.checked,
        data: addon.dataset
      }
    })
  }

  _addonToTrackingProps(data) {
    return {
      product_id: parseInt(data.metricProduct_id),
      sku: data.metricSku,
      category: data.metricCategory,
      name: data.metricName,
      price: parseFloat(data.metricPrice),
      quantity: parseInt(data.metricQuantity),
      value: parseFloat(data.metricValue),
      url: data.metricUrl
    }
  }

  _scrollToSection() {
    const sections = document.getElementsByClassName("product-section")
    const params = new URLSearchParams(window.location.search)

    Array.from(sections).forEach((section) => {
      if (params.has(section.id)) {
        const element = document.getElementById(section.id)
        element.scrollIntoView()
      }
    })
  }
}
